// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"635":"acb11df5","755":"afd8dd71"}[chunkId] + ".chunk.css";
};